import { FlowRole } from '@flowio/api-constants';

export function hasOnlyClassificationRoles(roles: io.flow.v0.enums.FlowRole[]): boolean {
  return roles.length === 1
      && roles[0] === FlowRole.ORGANIZATION_CLASSIFICATION;
}

export default function isClassificationUser(
  organizationId: string,
  memberships: io.flow.v0.models.Membership[],
): boolean {
  const orgMembership = memberships.find(
    (membership) => membership.organization.id === organizationId,
  );
  return (
    (orgMembership || false)
      && hasOnlyClassificationRoles(orgMembership.roles)
  );
}
